cb.define([], function () {
  var AP_ap_adjustprice_VM_Extend = {

    doAction: function (name, viewmodel) {
      if (this[name]) {
        this[name](viewmodel);
      }
    },
    init: function (viewmodel) {
		var self = this;
		var detailModel = viewmodel.get("adjustPriceDetail");
		var storeModel = viewmodel.get("adjustPriceStore");
		var regionModel = viewmodel.get("adjustPriceRegion");
		var memberlevelModel = viewmodel.get("adjustPriceMemberlevel");
		viewmodel.on("beforeAddRow", function(condition) {
			debugger;
			if (condition && condition.params && condition.params.cCommand)
			{//处理调价单门店和地区互斥，否则交叉以后无法处理 大区定价与明细门店定价
				if (condition.params.cCommand=="cmdAddRow_region")
				{
					if (storeModel.getRows().length>0)
					{
						cb.utils.alert("当前调价已经定义适用门店，不能定义适用地区");
						return false;					
					}
				}
				if (condition.params.cCommand=="cmdAddRow_store")
				{
					if (regionModel.getRows().length>0)
					{
						cb.utils.alert("当前调价已经定义适用地区，不能定义适用门店");
						return false;					
					}				
				}				
			}

		});		
		if(detailModel) { 
			detailModel.on('beforeBrowse', function (data) {
				if(data != undefined)
				{
					switch (data.cellName) {
						case "product_name":{
							var ProductClassid=this.getCellValue(data.rowIndex, 'productclass')
							if (ProductClassid!="" && ProductClassid!=undefined)
							{							
								var condition = {"isExtend": true, simpleVOs: [] };
								condition.simpleVOs.push({
									field: 'productClass',
									op: 'eq',
									value1: ProductClassid
								});
							}
							data.context.setFilter(condition);
							break;
						}
						case "productsku_name":
						{
							var Productid=this.getCellValue(data.rowIndex, 'product')
							if (Productid!="" && Productid!=undefined)
							{							
								var condition = {"isExtend": true, simpleVOs: [] };
								condition.simpleVOs.push({
								field: 'id',
								op: 'eq',
								value1: Productid
							});
							
							}
							data.context.setFilter(condition);
							break;
						}
					  
					}
				}				
			});
			//单元格值改变以后，如果是商品变了，就清空sku,如果商品大类变了，清空sku和商品
			detailModel.on('afterCellValueChange', function (data){
				switch (data.cellName) {
					case "product_name" : {
						detailModel.setCellValue(data.rowIndex, 'productsku_name',  null);
						detailModel.setCellValue(data.rowIndex, 'productsku_code',  null);
						detailModel.setCellValue(data.rowIndex, 'productsku',  null);
						break;
					}
					case "productclass_name" : {
						detailModel.setCellValue(data.rowIndex, 'product_name',  null);
						detailModel.setCellValue(data.rowIndex, 'product_code',  null);
						detailModel.setCellValue(data.rowIndex, 'product',  null);
						detailModel.setCellValue(data.rowIndex, 'productsku_name',  null);
						detailModel.setCellValue(data.rowIndex, 'productsku_code',  null);
						detailModel.setCellValue(data.rowIndex, 'productsku',  null);
						break;
					}
				}
			})
		}
		if(storeModel)
		{
			//过滤掉列表存在的数据
			storeModel.on('beforeBrowse', function (data) {
				if(data != undefined)
				{
					var rows = storeModel.getRows();
					var id = [];
					rows.forEach(function (item, index) {
						if (data.rowIndex === index) return;
						if (item.store_name === undefined) return;
						id.push(item.store);
					})
					switch (data.cellName) {
						case "store_name":
						var condition = { "isExtend": true, simpleVOs: [] };
						condition.simpleVOs.push({
						field: 'id',
						op: 'nin',
						value1: id
					  });
					  data.context.setFilter(condition);
					  break;
					}
				}
			});
			//已经选择的门店不能再次选择
			storeModel.on('beforeCellValueChange', function (data) {
			  if (data.cellName === 'store_name') {
				var rows = storeModel.getRows();
				var storeid = [];
				rows.forEach(function (item, index) {
				  if (data.rowIndex === index) return;
				  storeid.push(item.store);
				})
				if(data.value != undefined)
				{
					if (storeid.indexOf(data.value.id) > -1)
						return false;
				}
			  }
			});
		}
		if(regionModel) //树形参照无法处理，在保存时控制
		{

		}

		if(memberlevelModel)
		{
			//过滤掉列表存在的数据
			memberlevelModel.on('beforeBrowse', function (data) {
				if(data != undefined)
				{
					var rows = memberlevelModel.getRows();
					var id = [];
					rows.forEach(function (item, index) {
						if (data.rowIndex === index) return;
						if (item.memberlevel_cMemberLevelName === undefined) return;
						id.push(item.memberlevel);
					})
					switch (data.cellName) {
						case "memberlevel_cMemberLevelName":
						var condition = { "isExtend": true, simpleVOs: [] };
						condition.simpleVOs.push({
						field: 'id',
						op: 'nin',
						value1: id
					  });
					  data.context.setFilter(condition);
					  break;
					}
				}
			});
			//已经选择的会员级别不能再次选择
			memberlevelModel.on('beforeCellValueChange', function (data) {
			  if (data.cellName === 'memberlevel_cMemberLevelName') {
				var rows = memberlevelModel.getRows();
				var memberlevelid = [];
				rows.forEach(function (item, index) {
				  if (data.rowIndex === index) return;
				  memberlevelid.push(item.memberlevel);
				})
				if(data.value != undefined)
				{
					if (memberlevelid.indexOf(data.value.id) > -1)
						return false;
				}
			  }
			});
		}
		viewmodel.on('beforeSave', function(args) {
			return savecheck(args);
		});

		viewmodel.on('beforeSaveandadd', function(args) {
			if (args.params.cAction=="saveandadd")
			{
				return savecheck(args);
			}
		});

		var savecheck = function(args){
			var that = this;
			var irow;
			var jrow;
			var detailModel = viewmodel.get("adjustPriceDetail");
			var storeModel = viewmodel.get("adjustPriceStore");
			var regionModel = viewmodel.get("adjustPriceRegion");
			var memberlevelModel = viewmodel.get("adjustPriceMemberlevel");		

			//检查存货大类，存货，sku，生失效日期
			if (detailModel)
			{
				var detailModellength = detailModel.getRows().length;
				for (var i = 0; i < detailModellength; i++) {
					for (var j=i+1;j<detailModellength;j++){ //双循环中处理重复校验
						if (detailModel.getCellValue(i,'productclass')==detailModel.getCellValue(j,'productclass') && detailModel.getCellValue(i,'product')==detailModel.getCellValue(j,'product') && detailModel.getCellValue(i,'productsku')==detailModel.getCellValue(j,'productsku') && detailModel.getCellValue(i,'dEffectiveDate')==detailModel.getCellValue(j,'dEffectiveDate') && detailModel.getCellValue(i,'dExpiryDate')==detailModel.getCellValue(j,'dExpiryDate'))
						{
							irow=i+1;
							jrow=j+1;
							cb.utils.alert("第"+irow+"行["+detailModel.getColumn("productclass_name").cShowCaption+"+"+detailModel.getColumn("product_name").cShowCaption+"+"+detailModel.getColumn("productsku_name").cShowCaption+"+"+detailModel.getColumn("dEffectiveDate").cShowCaption+"+"+detailModel.getColumn("dExpiryDate").cShowCaption+"]与第"+jrow+"行重复，请检查后重试！");
							return false;							
						}							
					}
				}				
			}	
			//检查地区
			if (regionModel)
			{
				var regionModellength = regionModel.getRows().length;
				for (var i = 0; i < regionModellength; i++) {
					for (var j=i+1;j<regionModellength;j++){ //双循环中处理重复校验
						if (regionModel.getCellValue(i, 'region')==regionModel.getCellValue(j, 'region'))
						{
							irow=i+1;
							jrow=j+1;
							cb.utils.alert("第"+irow+"行["+regionModel.getColumn("region_name").cShowCaption+"]与第"+jrow+"行重复，请检查后重试！");
							return false;							
						}							
					}
				}				
			}			
		};

    },

  }
  try {
    module.exports = AP_ap_adjustprice_VM_Extend;
  } catch (error) {

  }
  return AP_ap_adjustprice_VM_Extend;
});



// WEBPACK FOOTER //
// ./src/client/business/AP/AP_ap_adjustprice_VM.Extend.js.js